import script from "./ValidacaoPIN_60.vue?vue&type=script&setup=true&lang=js"
export * from "./ValidacaoPIN_60.vue?vue&type=script&setup=true&lang=js"

import "./ValidacaoPIN_60.vue?vue&type=style&index=0&id=7cb54749&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7cb54749"]])

export default __exports__